function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.3.2a-SA_cntnt_rpo_MASTER-COVER",
  transform: "translate(-695.000000, -146.000000)"
}, React.createElement("g", {
  id: "icon/bulk-edit",
  transform: "translate(695.000000, 146.000000)"
}, React.createElement("g", {
  id: "noun_Gear_2434677-Copy",
  stroke: "#636363"
}, React.createElement("g", {
  id: "Group-8"
}, React.createElement("g", {
  id: "secondary-button"
}, React.createElement("rect", {
  id: "Rectangle-Copy-4",
  x: 0.5,
  y: 0.5,
  width: 39,
  height: 39,
  rx: 4
})))), React.createElement("g", {
  id: "Group",
  transform: "translate(12.000000, 14.000000)"
}, React.createElement("g", {
  id: "Group-19",
  transform: "translate(0.000000, 0.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 4.78405316,
  y: 0.0177187154,
  width: 10.1705426,
  height: 2.48062016
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.78405316,
  y: 4.80177187,
  width: 10.1705426,
  height: 2.48062016
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.78405316,
  y: 9.58582503,
  width: 10.1705426,
  height: 2.48062016
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.6673776e-13,
  y: -2.53796983e-13,
  width: 2.55149502,
  height: 2.48062016
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.6673776e-13,
  y: 4.78405316,
  width: 2.55149502,
  height: 2.48062016
}), React.createElement("rect", {
  id: "Rectangle",
  x: 4.6673776e-13,
  y: 9.56810631,
  width: 2.55149502,
  height: 2.48062016
})), React.createElement("polygon", {
  id: "Rectangle",
  fill: "#F4F7FC",
  transform: "translate(13.964439, 10.755136) rotate(45.000000) translate(-13.964439, -10.755136) ",
  points: "10.6311054 1.23132688 17.2977721 1.23132688 17.2977721 20.2789459 10.6311054 20.2789459"
}), React.createElement("path", {
  d: "M15.9812605,5.67486304 L18.2479602,7.94156275 L11.6740132,14.5155098 L9.40731348,12.2488101 L15.9812605,5.67486304 Z M8.94161969,12.786337 L11.1325283,14.9772456 L8.07962285,15.7314928 L8.94161969,12.786337 Z M17.7770873,3.8790363 L20.043787,6.145736 L18.9618804,7.2276426 L16.6951807,4.9609429 L17.7770873,3.8790363 Z",
  id: "Combined-Shape",
  fill: "#636363"
})))));

const SvgBulkEdit = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgBulkEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bulk-edit.0cefa9f8.svg";
export { ForwardRef as ReactComponent };